import { Component, Input, OnInit } from '@angular/core';
import { Project } from 'src/app/shared/models';

@Component({
    selector: 'app-project-labor-setup',
    templateUrl: './labor-setup.component.html',
    styleUrls: ['./labor-setup.component.scss'],
    standalone: false
})
export class LaborSetupComponent implements OnInit {

  @Input() project: Project;
  constructor() { }

  ngOnInit(): void {
  }

}
